module.exports = __webpack_public_path__ + "static/img/icon2@2x.897d238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon2@2x.png
// module id = PJHG
// module chunks = 69